export default "__VITE_ASSET__CegcxT_q__"